import { Link } from 'react-router-dom';
import ListErrors from './ListErrors';
import React from 'react';
import agent from '../agent';
import { connect } from 'react-redux';
import {
    DEPOSIT_BANK_REFERENCE_CODE_UNLOAD,
    DEPOSIT_FILE_UPLOADED
} from '../constants/actionTypes';

const mapStateToProps = state => ({
    ...state.task,
    currentUser: state.common.currentUser,
    inProgress: state.common.inProgress,
});

const mapDispatchToProps = dispatch => ({
    onUnload: () => dispatch({ type: DEPOSIT_BANK_REFERENCE_CODE_UNLOAD }),
    uploadDepositFile: (payload, upload_deposit_file) =>
        dispatch({ type: DEPOSIT_FILE_UPLOADED, payload, upload_deposit_file})
});

class DepositWithReferenceCode extends React.Component {
    constructor() {
        super();

        this.state = {
            code: '',
            amount: '',
            upload_deposit_file: null,
            upload_response_received: false,
            upload_items_total_processed: 0,
            upload_items_total_success: 0,
            upload_items_total_errors: 0,
            upload_item_errors: null
          }

        this.selectUploadDepositFile = () => ev => {
            let input = ev.target;
            if (input.files && input.files[0]) {
              this.setState({ upload_deposit_file: input.files[0] });
            }
        }
        this.upload = (upload_deposit_file) => ev => {
            ev.preventDefault()
            const payload = agent.Tasks.upload('Account.Deposit', 'Verify', upload_deposit_file)

            this.props.uploadDepositFile(payload, upload_deposit_file)

        }
    }
    componentWillMount(props) {
        if (this.props.currentUser) {
            Object.assign(this.state, {
            })
        }
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.upload_response_received) {
          var response = nextProps.upload_response

          this.setState({ upload_response_received: true,
            upload_items_total_processed: response.total_items_processed,
            upload_items_total_success: response.success_count,
            upload_items_total_errors: response.error_count,
            upload_item_errors: response.import_errors
          })
        }
      }
    componentWillUnmount() {
        this.props.onUnload();
    }
    handlePageChanged(newPage) {
        const pageIndex = newPage + 1;
        const terms = this.props.searchTerm || ''
        const date_from = this.props.date_from || ''
        const date_to = this.props.date_to || ''
        const status = this.props.status || ''
        this.props.onLoadNextPage(agent.Tasks.list('Account.Deposit', 'Transfer', status, pageIndex, terms, date_from, date_to), status, pageIndex, terms, date_from, date_to);
      }

    render() {
        const code = this.state.code;
        const amount = this.state.amount;
        const inProgress = this.props.inProgress

        let upload_deposit_file = this.state.upload_deposit_file
        let upload_response_received = this.state.upload_response_received
        let responseElement = null
        let errorResponseElement = ``
        let importErrors = this.state.upload_item_errors

        if (upload_response_received)
        {
          responseElement =
            <div className="infoGroup">
              <div className="infoPair">
                <label>Total Items Processed:</label> <span>{this.state.upload_items_total_processed} </span>
              </div>
              <div className="infoPair">
                <label>Success Count:</label> <span>{this.state.upload_items_total_success} </span>
              </div>
              <div className="infoPair">
                <label>Error Count:</label> <span>{this.state.upload_items_total_errors} </span>
              </div>
              <div>
              {
                importErrors.map(error => {
                  return (<div><span>Line:{error.line} Error: {error.error}</span></div>)
                })
              }
              </div>
          </div>
        }

        return (
            <div class='pane'>
                <h1>Upload Deposits with Bank Reference Code</h1>
                <ListErrors errors={this.props.errors} />
                <fieldset className="form">
                    <div className="infoGroup">
                        <div className="infoAction">
                            <input type="file" onChange={this.selectUploadDepositFile()}  />
                            <button className="buttonAction" onClick={this.upload(upload_deposit_file)}>Upload</button>
                            {responseElement}
                        </div>
                    </div>
                </fieldset>
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DepositWithReferenceCode);



// WEBPACK FOOTER //
// ./src/components/DepositWithReferenceCode.js